import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '@services/authService';
import { Loading } from '@components/Loading';

/**
 * OAuth callback handler
 * Processes the authorization code from Keycloak before redirecting
 */
export function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      console.log('=== AuthCallback: Processing OAuth callback ===');
      console.log('Current URL:', window.location.href);
      console.log('URL params:', window.location.search);

      // Extract auth code from URL - check both query params and hash fragment
      // Keycloak might use hash fragment (#) instead of query string (?)
      let urlParams = new URLSearchParams(window.location.search);
      let code = urlParams.get('code');
      let state = urlParams.get('state');

      // If not in query string, check hash fragment
      if (!code && window.location.hash) {
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        code = hashParams.get('code');
        state = hashParams.get('state');
        console.log('AuthCallback: Found params in hash fragment');
      }

      console.log('AuthCallback: Auth code present:', !!code);
      console.log('AuthCallback: State present:', !!state);
      console.log('AuthCallback: Code value:', code?.substring(0, 20) + '...');

      if (!code) {
        console.error('AuthCallback: No authorization code in URL');
        navigate('/login', { replace: true });
        return;
      }

      try {
        // Force reinitialization to process the callback
        const authenticated = await authService.initializeCallback();

        console.log('AuthCallback: Authentication result:', authenticated);
        console.log('AuthCallback: Token present:', !!authService.getToken());

        if (authenticated && authService.getToken()) {
          // Successfully authenticated with token
          console.log('AuthCallback: Redirecting to dashboard');
          navigate('/dashboard', { replace: true });
        } else {
          // Authentication failed or no token
          console.error('AuthCallback: Authentication failed or no token');
          navigate('/login', { replace: true });
        }
      } catch (error) {
        console.error('AuthCallback: Error during callback processing:', error);
        navigate('/login', { replace: true });
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="flex h-screen items-center justify-center">
      <Loading size="lg" message="Completing authentication..." />
    </div>
  );
}
